import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback, useMemo } from 'react';
import { PushPin, PushPinOutlined } from '@mui/icons-material';
import { Box, IconButton } from '@mui/material';
import { useDashboard } from 'console/dashboards/z3k/provider';
import { useDashboardControl } from 'console/dashboards/z3k/provider/control';
import * as S from './styles';
import { useSortableGridResize } from 'console/shared/hooks/layout';
import { useResizeDetector } from 'react-resize-detector';
const pin_button_sx = {
    position: 'absolute',
    bottom: 10,
    right: 15,
    transform: 'rotate(45deg)',
};
const style = { width: '100%', height: '100%' };
export const MediumUISortableDevices = memo(function MediumUISortableDevices(props) {
    const { component, devices } = props;
    const { dashboard_ui_settings, sorting_mode } = useDashboard();
    const { onDevicePin, onDeviceBlockInteractionEnd } = useDashboardControl();
    const { width, height, ref } = useResizeDetector({ handleHeight: false });
    const layout = useMemo(() => Object.values(dashboard_ui_settings).map((ui_settings) => {
        const { id: i, x, y, height: h, width: w, pinned } = ui_settings;
        return {
            i,
            x,
            y,
            w,
            h,
            minH: 8,
            minW: 4,
            static: pinned,
            isBounded: true,
        };
    }), [dashboard_ui_settings]);
    const onDevicePinClick = useCallback((id) => () => {
        onDevicePin(id);
    }, []);
    const layouts = useMemo(() => ({ lg: layout, md: layout, sm: layout, xs: layout, xxs: layout }), [layout]);
    const content = useMemo(() => devices.map(({ id: device_id }) => {
        const pinned = dashboard_ui_settings[device_id]?.pinned ?? false;
        return (_jsxs(Box, { position: "relative", height: "100%", children: [_jsx(Box, { height: "100%", overflow: "auto", children: component(device_id) }), sorting_mode && (_jsx(IconButton, { sx: pin_button_sx, size: "small", onPointerDown: onDevicePinClick(device_id), children: pinned ? (_jsx(PushPin, { color: "primary" })) : (_jsx(PushPinOutlined, {})) }))] }, device_id));
    }), [dashboard_ui_settings, sorting_mode, component, devices]);
    const resize_ref = useSortableGridResize(width);
    return (_jsx("div", { ref: ref, style: style, children: _jsx(S.SortableDevicesGridLayout, { layouts: layouts, autoSize: true, onLayoutChange: onDeviceBlockInteractionEnd, isResizable: sorting_mode, isDraggable: sorting_mode, useCSSTransforms: true, ref: resize_ref, cols: { lg: 12, md: 12, sm: 12, xs: 12, xxs: 12 }, rowHeight: 24, draggableHandle: ".dashboard-device-header", resizeHandles: ['s', 'w', 'e', 'n', 'sw', 'nw', 'se', 'ne'], className: sorting_mode ? 'dashboard-sorting-mode' : undefined, compactType: "vertical", children: content }) }));
});
